module.exports = __webpack_public_path__ + "static/BackgroundVideo_6Mbps-460d277bd29e60d609a08c8a82659ada.mp4";